import { Link } from "react-router-dom";

import Text from "../../styleguide/Text";
import { isDevelop } from "../../helpers/apiHelper";
import { toAbsoluteUrl } from "../../helpers/assetHelper";

function NavbarLogo({
  withEnvIndicator,
  style,
}: {
  withEnvIndicator?: boolean;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className="flex h-full items-center"
      style={{ marginLeft: 10, ...style }}>
      <Link className="flex h-full items-center text-inherit no-underline" to="/" tabIndex={-1}>
        <img width={110} height={33} src={toAbsoluteUrl("/logo.svg")} alt="WMS" />
      </Link>
      {withEnvIndicator && isDevelop && (
        <Text variant="h1" className="ml-3">
          Develop
        </Text>
      )}
    </div>
  );
}

export default NavbarLogo;
